import { HrmActions } from "../../pages/components/hrm_actions";

export const adminFaqColumns = ({ onSelectAction }) => {
  return [
    {
      Header: "Sr. No.",
      accessor: "idd", // Assuming you set 'idd' correctly in the data
      Cell: ({ row }) => {
        return row.original.idd; // Return the idd value
      },
    },
    {
        Header: "Question",
        accessor: (row) => {
          return row?.question || "N/A";
        },
      },
    {
        Header: "Answer",
        accessor: (row) => {
          return row?.answer || "N/A";
        },
    },
    {
      Header: "Actions",
      accessor: (row) => {
        return (
          <div className="text-left">
            <HrmActions
              onSelectAction={onSelectAction}
              row={row}
              isDefault={true}
            />
          </div>
        );
      },
    },
  ];
};
